import React, { FunctionComponent } from 'react';
import { UncompleteItem } from '../../../types/personShow';

type Props = {
  uncompletes: UncompleteItem[];
  isLastIndex: (index: number) => boolean;
};

export const Presentation: FunctionComponent<Props> = ({
  uncompletes,
  isLastIndex,
}) => {
  return (
    <div className='person__show__main__alert'>
      <p className="person__show__main__alert--title">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.99962 11.9838C8.16667 11.9838 8.30404 11.9301 8.41173 11.8226C8.51942 11.7152 8.57326 11.5779 8.57326 11.4109C8.57326 11.2438 8.51955 11.1065 8.41211 10.9988C8.30467 10.8911 8.16743 10.8373 8.00038 10.8373C7.83333 10.8373 7.69596 10.891 7.58827 10.9984C7.48058 11.1059 7.42673 11.2431 7.42673 11.4102C7.42673 11.5772 7.48045 11.7146 7.58789 11.8223C7.69533 11.93 7.83257 11.9838 7.99962 11.9838ZM7.56924 9.01377H8.52467V3.76033H7.56924V9.01377ZM8.00701 16C6.89887 16 5.86099 15.79 4.89338 15.3701C3.92577 14.9502 3.07837 14.3768 2.35116 13.6499C1.62395 12.923 1.05028 12.0754 0.63017 11.1072C0.210057 10.139 0 9.10021 0 7.99088C0 6.88695 0.209966 5.84931 0.629897 4.87795C1.04983 3.90659 1.62323 3.06082 2.35011 2.34064C3.077 1.62044 3.92456 1.05028 4.89279 0.630171C5.86102 0.210058 6.89979 0 8.00912 0C9.11305 0 10.1507 0.209966 11.1221 0.629897C12.0934 1.04983 12.9392 1.61972 13.6594 2.33959C14.3796 3.05946 14.9497 3.90598 15.3698 4.87915C15.7899 5.8523 16 6.89025 16 7.99299C16 9.10113 15.79 10.139 15.3701 11.1066C14.9502 12.0742 14.3803 12.9203 13.6604 13.645C12.9405 14.3696 12.094 14.9432 11.1209 15.3659C10.1477 15.7886 9.10975 16 8.00701 16Z" fill="#FF3B30" />
        </svg>
        プロフィールが未完成です
      </p>
      <div className="person__show__main__alert--text">
        <p>
          以下の項目を充実させることで、<br />
          スカウトが届きやすくなったり選考がスムーズに進む可能性が高まります。<br />
        </p>
        {uncompletes.length > 0 &&
          uncompletes.map((child, index) => (
            <React.Fragment key={child.name}>
              <a className="uncomplete" href={`#${child.id}`}>{child.name}</a>
              {!isLastIndex(index) && <strong className="devide">&nbsp;/&nbsp;</strong>}
            </React.Fragment>
          ))}
      </div>
    </div>
  );
};
